import React from 'react';
import { Navigate } from 'react-router-dom';

// Helper to decode JWT
function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

export const ProtectedUserRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;

  const decoded = parseJwt(token);
  if (decoded?.role !== 'user') return <Navigate to="/login" replace />;

  return children;
};

export const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;

  const decoded = parseJwt(token);
  if (decoded?.role !== 'admin') return <Navigate to="/login" replace />;

  return children;
};
